<template>
    <div
        :class="{ clicked: isClicked, checked: item.local.checked }"
        class="train-adjust-item-wrapper"
        v-if="!!item.tasks.length || item.local.modified"
        @click="handleClick"
    >
        <div class="adjust-item-header">
            <div class="adjust-item-header-left">
                <span class="adjust-item-title">
                    <div
                        :style="{ borderColor: color, backgroundColor: color }"
                        class="checkbox-background"
                    ></div>
                    <el-checkbox
                        :value="item.local.checked"
                        @change="handleCheck"
                    ></el-checkbox>
                    <!-- 车次号 -->
                    <span
                        class="
                            adjust-item-title-item adjust-item-title-trainNum
                        "
                        @dblclick="copyText(item.trainNum)"
                        >{{ item.trainNum }}</span
                    >
                    <span
                        :class="{
                            'adjust-item-modified': true,
                            'adjust-item-modified-true': item.local.modified,
                        }"
                        >已修改</span
                    >
                    <i
                        class="el-icon-view"
                        @click="handleDetailStatistics(item)"
                    ></i>
                    <div class="adjust-item-title-expand"></div>
                    <div class="adjust-item-header-actions">
                        <!-- 状态 -->
                        <div class="adjust-item-status">{{ statusName }}</div>
                        <el-button
                            v-if="
                                isToArrange &&
                                item.tasks.length > 0 &&
                                !item.local.modified
                            "
                            class="adjust-item-action"
                            type="primary"
                            @click="handleArrange"
                            >排车
                        </el-button>
                    </div>
                </span>
                <div v-if="isToArrange" class="adjust-item-info">
                    <!-- 订单数 -->
                    <span class="adjust-item-info-item">{{ cOrderNum }}票</span>
                    <!-- 方数 -->
                    <span class="adjust-item-info-item">{{ cVolume }}m³</span>
                    <!-- 串点数 -->
                    <span class="adjust-item-info-item"
                        >{{ item.pointNum }}站</span
                    >
                    <!-- 里程 -->
                    <span class="adjust-item-info-item"
                        >{{ cOrderMile }}km</span
                    >
                    <!-- 推荐车型 -->
                    <span class="adjust-item-info-item"
                        >{{ item.truckModel }}米</span
                    >
                </div>

                <div v-else class="adjust-item-info">
                    <!-- 发车单号 -->
                    <span class="adjust-item-title-item">{{
                        item.dispatchNo
                    }}</span>
                    <!-- 车辆信息 -->
                    <span class="adjust-item-title-item">{{
                        item.vehicleCard
                    }}</span>
                    <!-- 司机信息 -->
                    <span class="adjust-item-title-item">{{
                        item.driver
                    }}</span>
                    <!-- 订单数 -->
                    <span class="adjust-item-info-item">{{ cOrderNum }}票</span>
                    <!-- 方数 -->
                    <span class="adjust-item-info-item">{{ cVolume }}m³</span>
                    <!-- 串点数 -->
                    <span class="adjust-item-info-item"
                        >{{ item.pointNum }}站</span
                    >
                    <!-- 里程 -->
                    <span class="adjust-item-info-item"
                        >{{ item.mileage }}km</span
                    >
                    <!-- 推荐车型 -->
                    <span class="adjust-item-info-item"
                        >{{ item.truckModel }}米</span
                    >
                    <!-- 装载率: 状态 > "待发车" -->
                    <!-- <span class="adjust-item-info-item">{{ item.loadPercent }}%</span> -->
                </div>
            </div>
        </div>
        <div class="adjust-item-expand-toggle-row">
            <div
                :class="{ 'toggle-disabled': !expandedToggleable }"
                class="adjust-item-expand-toggle"
                @click="handleToggleExpanded"
            >
                <i
                    :class="
                        item.local.expanded || !expandedToggleable
                            ? 'el-icon-arrow-up'
                            : 'el-icon-arrow-down'
                    "
                ></i>
            </div>
        </div>
        <div class="adjust-item-content">
            <slot v-bind:tasks="item.tasks"></slot>
        </div>
        <el-dialog
            title="查看明细"
            :visible.sync="detailVisible"
            append-to-body
            width="65%"
        >
            <el-table border :data="detailStatistics">
                <el-table-column
                    property="customerItemCode"
                    label="客户商品编码"
                    width="130"
                    sortable
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    property="itemName"
                    label="商品名称"
                    width="300"
                    sortable
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    property="itemClass"
                    label="商品分类"
                    sortable
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    property="planQty"
                    label="数量"
                    sortable
                ></el-table-column>
                <el-table-column
                    property="volume"
                    label="方量(m³)"
                    sortable
                ></el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import { twink } from '../utils/animation';
import { TrainStatusNameTranslator } from '../utils/train';
import * as api from '../../../../api/trainList';
import { TrainEntity } from '../entity/trainEntity';

export default {
    name: 'train-adjust-item',
    props: {
        item: {
            type: Object
        },
        color: String
    },
    data () {
        return {
            isClicked: false,
            statusTranslator: null,
            detailVisible: false,
            detailStatistics: []
        };
    },
    computed: {
        // 待排车
        isToArrange () {
            return TrainEntity.statusIsToArrange(this.item);
        },
        // 是否可以切换运单列表的 展开/收拢
        expandedToggleable () {
            return this.item.tasks.length > 1;
        },
        statusName () {
            return this.statusTranslator
                ? this.statusTranslator.toName(this.item.dispatchStatus, this.item.dispatchStatus)
                : this.item.dispatchStatus;
        },
        cOrderNum () {
            return TrainEntity.statusIsToArrange(this.item) ? TrainEntity.computeOrderNum(this.item) : this.item.orderNum;
        },
        cVolume () {
            return TrainEntity.statusIsToArrange(this.item) ? TrainEntity.computeVolume(this.item) : this.item.volume;
        },
        cOrderMile () {
            return TrainEntity.statusIsToArrange(this.item) && this.item.tasks.length ? this.item.mileage : 0;
        }
    },
    created () {
        // 转换状态名称
        TrainStatusNameTranslator.create()
            .then(t => {
                this.statusTranslator = t;
            });
    },
    methods: {
        handleDetailStatistics (data) {
            this.detailVisible = true;
            this.detailStatistics = [];
            const taskNoList = data.tasks.map(item => item.taskNo);
            api.getDetailStatistics(taskNoList).then(res => {
                if (res) {
                    this.detailStatistics = res.data.list || [];
                }
            });
        },
        handleArrange (e) {
            e.stopPropagation();
            this.$emit('on-item-event', { eventName: 'arrange', item: this.item });
        },
        handleCheck (isChecked) {
            this.$emit('on-item-event', { eventName: 'check', item: this.item, isChecked });
            if (this.item.tasks.length > 1) {
                this.$emit('on-item-event', { eventName: 'expanded', item: this.item, isExpanded: isChecked });
            }
        },
        handleClick (e) {
            e.stopPropagation();
            if (e.target.className.includes('el-checkbox')) {
                return;
            }
            this.$emit('on-item-event', { eventName: 'click', item: this.item });
        },
        handleToggleExpanded (e) {
            e.stopPropagation();
            if (this.item.tasks.length > 1) {
                this.$emit('on-item-event', { eventName: 'expanded', item: this.item, isExpanded: !this.item.local.expanded });
            }
        },
        twink () {
            if (this.item.local.checked) {
                twink(() => {
                    this.isClicked = true;
                }, () => {
                    this.isClicked = false;
                });
            }
        },
        // 车次双击复制函数
        copyText (copyText) {
            var input = document.createElement('input');
            input.type = 'text';
            input.value = copyText.trim();
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            this.$message.success(`车次号 ‘${input.value}’ 复制成功`);
        }
    },
    watch: {
        'item.local.modified': {
            handler: function (val, oldVal) {
                if (val) {
                    if (this.item.tasks.length > 1) {
                        this.$emit('on-item-event', { eventName: 'expanded', item: this.item, isExpanded: true });
                    }
                }
            }
        }
    }

};
</script>

<style lang="less" scoped>
.train-adjust-item-wrapper {
    background-color: #f5f8fa;
    margin-bottom: 8px;
    border-radius: 6px;
    padding: 0;
    //border-left: 10px solid black;
    border: 1px solid #ebeef5;
    .el-icon-view {
        color: #00bcbf;
        font-size: 20px;
        cursor: pointer;
    }
    &.clicked {
        background-color: #c3c3c332;
        box-shadow: 0 0 10px 0 #c3c3c332;
        transition: background-color 200ms ease-in-out;
    }

    &.checked {
        background-color: white;
    }

    .adjust-item-header {
        display: flex;
        justify-content: space-between;
        padding: 10px 14px 0 14px;
        font-size: 15px;
        color: #2c2931;

        .adjust-item-header-left {
            display: flex;
            flex-direction: column;
            align-items: start;
            flex-wrap: wrap;
            width: 100%;
        }

        .adjust-item-title {
            display: flex;
            align-items: center;
            width: 100%;
            height: 28px;
            position: relative;

            :nth-child(2) {
                margin-right: 6px;
            }

            .checkbox-background {
                position: absolute;
                left: 0;
                width: 16px;
                height: 16px;
                border-radius: 4px;
            }

            .adjust-item-title-expand {
                flex-grow: 1;
            }

            .dispatch-no {
                font-weight: bold;
            }

            .adjust-item-modified {
                display: none;
                color: salmon;
                margin-right: 10px;

                &.adjust-item-modified-true {
                    display: inline;
                }
            }
        }

        .adjust-item-info {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            font-size: 14px;
            color: #94979a;
        }

        .adjust-item-title-item,
        .adjust-item-info-item {
            padding: 0 8px 0 0;
            margin-right: 8px;
            border-right: 1px solid #f4f7fa;

            white-space: nowrap;

            &:last-of-type {
                border-right: 0;
                margin-right: 0;
            }
        }
        .adjust-item-title-trainNum {
            cursor: pointer;
        }
        .adjust-item-header-actions {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: end;

            .adjust-item-action {
                margin-left: 8px;
            }

            .adjust-item-status {
                text-align: right;
                min-width: 60px;
                position: relative;
            }
        }
    }

    .adjust-item-expand-toggle-row {
        border-bottom: 1px solid #e9eff3;
        text-align: right;
        margin-top: -9px;

        .adjust-item-expand-toggle {
            position: relative;
            top: 18px;
            display: inline-block;
            background-color: #c3c3c333;
            border-radius: 0 0 4px 4px;
            padding: 0 6px;
            margin-right: 14px;
            color: #898c8c;

            &.toggle-disabled {
                color: #c3c3c377;
                visibility: hidden;
            }
        }
    }

    .adjust-item-content {
        padding: 14px;
    }
}
</style>

<style lang="less">
.adjust-item-header-left {
    .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: transparent;
        border-color: transparent;
    }

    .el-checkbox__inner {
        position: relative;
        top: 1px;
        width: 16px;
        height: 16px;

        &:after {
            top: 2px;
            left: 5px;
        }
    }
}
</style>
